<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiMessageText } from "@mdi/js";
export default {
  name: "MdiMessageText",
  data() {
    return {
      svgPath: mdiMessageText,
    };
  },
};
</script>
